window.addEventListener("scroll", function () {
  const header = document.getElementById("main-nav");
  const logo = document.getElementById("logo-header");

  if (window.scrollY > 100) {
    header.classList.add("bg-white", "shadow-md");
    header.classList.remove("bg-transparent");
    
    if (document.body.classList.contains('page-id-56')) {
      // only for homepage
      logo.classList.remove("hidden");
    }
    // header
    //   .querySelectorAll("a")
    //   .forEach((link) => link.classList.add("text-gray-900"));
    // header
    //   .querySelectorAll("a")
    //   .forEach((link) => link.classList.remove("text-white"));
  } else {
    // Classes to restore when at the top
    header.classList.remove("bg-white", "shadow-md");
    header.classList.add("bg-transparent");

    if (document.body.classList.contains('page-id-56')) {
      // only for homepage
      logo.classList.add("hidden");
    }

    // header
    //   .querySelectorAll("a")
    //   .forEach((link) => link.classList.remove("text-gray-900"));
    // header
    //   .querySelectorAll("a")
    //   .forEach((link) => link.classList.add("text-white"));
  }
});
